import { PreprocessedCurrencySchema } from "@open-revenue/schema/stripe";
import { Schema } from "effect";
export class StripePrice extends Schema.Class("open-revenue-stripe-StripePrice")({
    id: Schema.String,
    product: Schema.String,
    currency: PreprocessedCurrencySchema,
    type: Schema.Union(Schema.Literal("one_time"), Schema.Literal("recurring")),
    unit_amount: Schema.Union(Schema.Number, Schema.Null),
    recurring: Schema.Union(Schema.Null, Schema.Struct({
        interval: Schema.Union(Schema.Literal("day"), Schema.Literal("week"), Schema.Literal("month"), Schema.Literal("year")),
        interval_count: Schema.Number
    }))
}) {
}
